import {QuizzesRequire, QuizzesRequireHrLockAt} from '@/models/Quiz';

export class Quizzes implements QuizzesRequireHrLockAt, QuizzesRequire {
  requireOsh: boolean = false;
  requireKnf: boolean = false;
  requireAml: boolean = false;
  requireRodo: boolean = false;
  requireCyber: boolean = false;
  requireStmt: boolean = false;
  requireEthic: boolean = false;
  requireStmtHrLockAt?: Date;
  requireEthicHrLockAt?: Date;
}
export class QuizzesToSend {
  requireOshQuiz: boolean = false;
  requireKnfQuiz: boolean = false;
  requireAmlQuiz: boolean = false;
  requireRodoQuiz: boolean = false;
  requireCyberQuiz: boolean = false;
}
